module.exports = __webpack_public_path__ + "img/img130.ee3d60a2.svg";